import React from 'react';
const ReAuthDialog: React.FC = () => {
  return <></>;
};

export default ReAuthDialog;
